import HeadingRoot from './Heading';
export * from './Heading.constants';
export * from './Heading.mixins';
export * from './Heading.props';
export * from './Heading.types';
export default HeadingRoot;
